export default __webpack_public_path__ + "static/media/toy-cars.82ac21f3.jpeg";